export default __webpack_public_path__ + "static/media/mates-lads-gif.b749143a.gif";